(function () {
    var ClientSelectorCtrl = (function () {
        function ClientSelectorCtrl() {
            this.init.apply(this, arguments);
        }

        ClientSelectorCtrl.prototype = {
            init: function ($scope, $mdDialog, MKioskService, client, $timeout, $mdPanel,$q) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$mdDialog = $mdDialog;
                this.MKioskService = MKioskService;
                this.client = client;
                this.$timeout = $timeout;
                this.$mdPanel = $mdPanel;
                this.$q=$q;


                var _this=this;
                this.querySearch = "";
                this.isShowSearch = false;
                this.clients = [];
                this.getData().then(function (clients) {
                    _this.clients = clients;
                });


            },
            ready: function () {
                this.$element = $("#internal-clientsselector-page");
            },
            getData: function () {
                return this.MKioskService.getClients();
            },
            filter: function (keysearch) {
                return this.MKioskService.getClients(keysearch).then(angular.bind(this, function (clients) {
                    this.clients.splice(0, this.clients.length);
                    _.each(clients, function (client) {
                        this.clients.push(client);
                    }, this);

                    //Scroll to top and update content
                    var controller = this.$element.find("md-virtual-repeat-container").data("$mdVirtualRepeatContainerController");
                    controller.resetScroll();
                }));

            },
            enableSearch: function () {
                this.isShowSearch = true;
                this.$timeout(angular.bind(this, function () {
                    this.$element.find(".keysearch").focus();
                }), 500);
            },
            clearSearch: function () {
                this.querySearch = "";
                this.startSearch();
            },
            goBack: function () {
                this.$mdDialog.cancel();
            },
            startSearch: function () {
                this.filter(this.querySearch);
            },
            selectClient: function (client) {
                this.$mdDialog.hide(client);
            },
            showClientDialog: function (options) {
                var config = {
                    attachTo: angular.element(document.body),
                    controller: 'AddClientCtrl',
                    templateUrl: 'js/internal/addclient/addclient.view.html',
                    targetEvent: options.$event,
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    focusOnOpen: true,
                    panelClass: 'panel-clients-selector',
                    locals: {
                        onClose:function(client){
                            _.extend(options.client,client);
                        },
                        client: options.client,
                        prevRouter: options.prevRouter
                    }
                };
                var panelRef = this.$mdPanel.create(config);
                panelRef.open()
                    .finally(function () {
                        panelRef = undefined;
                    });
            },
            showAddClientDialog: function ($event) {
                this.showClientDialog({
                    $event: $event
                });
            },
            showEditClientDialog: function ($event, client) {
                $event.stopImmediatePropagation();
                this.showClientDialog({
                    $event: $event,
                    client: client,
                    prevRouter: "clients"
                });
            }
        };
        ClientSelectorCtrl.$inject = ['$scope', '$mdDialog', 'MKioskService', 'client', '$timeout', '$mdPanel','$q'];
        return ClientSelectorCtrl;
    }());
    angular.module('internal.clientselector', []).controller('ClientSelectorCtrl', ClientSelectorCtrl);
})();


